define(['jquery','inView'], function ($,inView) {
	tekanimate = {
		Init: function () {
			tekanimate.cbScroll();
			tekanimate.contactScroll();
			tekanimate.relatedScroll();
			tekanimate.animateScroll();
			tekanimate.landingSimpleScroll();
			tekanimate.landingSliderStart();
			tekanimate.slideLeft();
			tekanimate.slideRight();
			tekanimate.tileScroll();
			tekanimate.circle();
			
			//TO DO:find window offset and trigger scroll of 1px to fix animation issues.
			$(window).scrollTop($(window).scrollTop()+1);
		},
		inViewFunc: function (el) {
			if(!el.classList.contains('fadeInUp')){
				el.classList.add('fadeInUp');
			}
		},
		inViewFuncSimple: function(el){
			if(!el.classList.contains('fadeIn')){
				el.classList.add('fadeIn');
			}
		},
		inViewGraphAnimate: function(el){
			if(!el.classList.contains('graph--animate')){
				el.classList.add('graph--animate');
			}
		},
		inViewSlideLeft: function(el){
			if(!el.classList.contains('slide-left')){
				el.classList.add('slide-left');
			}
		},
		inViewSlideRight: function(el){
			if(!el.classList.contains('slide-right')){
				el.classList.add('slide-right');
			}
		},
		landingSimpleScroll: function(){
			inView('.animate-fade').on('enter', 
				function(el){
					tekanimate.inViewFuncSimple(el);
				}
			);
		},
		landingSliderStart: function(){
			inView('.graph--slider').on('enter', 
				function(el){
					tekanimate.inViewGraphAnimate(el);					
				}		
			);
		},
		slideLeft: function(){
			inView('.animate-left').on('enter', 
				function(el){
					tekanimate.inViewSlideLeft(el)
				}
			);
		},
		slideRight: function(){
			inView('.animate-right').on('enter', 
				function(el){
					tekanimate.inViewSlideRight(el)
				}
			);
		},
		cbScroll: function(){
			inView('.content-block').on('enter', 
				function(el){
					tekanimate.inViewFunc(el)
				}
			);
		},
		contactScroll: function(){
			inView('.animated-blocks .tek-clickable-highlight').on('enter', 
				function(el){
					tekanimate.inViewFunc(el)
				}
			);
		},
		relatedScroll: function(){ 
			inView('.related .tek-clickable-highlight').on('enter', 
				function(el){
					tekanimate.inViewFunc(el)
				}
			);
		},
		tileScroll: function(){ 
			inView('.tile').on('enter', 
				function(el){
					tekanimate.inViewFunc(el)
				}
			);
		},
		circle: function(){ 
			inView('.circle').on('enter', 
				function(el){
					tekanimate.inViewFunc(el)
				}
			);
		},
		animateScroll: function(){
			inView('.animate').on('enter', 
				function(el){
					tekanimate.inViewFunc(el)
				}
			);
		}
	}
	return tekanimate;
});

